import { create } from "zustand";
import type { FormQuestion, FormQuestionState } from "../types";
import { formQuestionApi } from "../services/form-question-api";

export const useFormQuestionStore = create<FormQuestionState>((set) => ({
	questions: null,

	index: async (workspaceId: string, formId: string) => {
		const response = await formQuestionApi.index(workspaceId, formId);

		if (response.success && response.data) {
			set({ questions: response.data });
		}

		return response;
	},

	show: async (id: string, workspaceId: string, formId: string) => {
		const response = await formQuestionApi.show(id, workspaceId, formId);

		return response;
	},

	create: async (workspaceId: string, formId: string, payload) => {
		const response = await formQuestionApi.create(workspaceId, formId, payload);

		if (response.success && response.data) {
			set((state) => ({
				questions: state.questions && response.data ? [...state.questions, response.data] : response.data ? [response.data] : state.questions ?? [],
			}));
		}

		return response;
	},

	update: async (id: string, workspaceId: string, formId: string, payload) => {
		const response = await formQuestionApi.update(id, workspaceId, formId, payload);

		if (response.success && response.data) {
			set((state) => ({
				questions: state.questions
					? state.questions.map((question) => (question.id === id ? response.data : question)).filter((question): question is FormQuestion => question !== null && question !== undefined)
					: [],
			}));
		}

		return response;
	},

	delete: async (id: string, workspaceId: string, formId: string) => {
		const response = await formQuestionApi.delete(id, workspaceId, formId);

		if (response.success) {
			set((state) => ({
				questions: (state.questions ?? []).filter((question) => question.id !== id),
			}));
		}

		return response;
	},

	restore: async (id: string, workspaceId: string, formId: string) => {
		const response = await formQuestionApi.restore(id, workspaceId, formId);

		if (response.success && response.data) {
			set((state) => ({
				questions: state.questions && response.data ? [...state.questions, response.data] : response.data ? [response.data] : state.questions ?? [],
			}));
		}

		return response;
	},

	forceDelete: async (id: string, workspaceId: string, formId: string) => {
		const response = await formQuestionApi.forceDelete(id, workspaceId, formId);

		if (response.success) {
			set((state) => ({
				questions: (state.questions ?? []).filter((question) => question.id !== id),
			}));
		}

		return response;
	},
}));
